import { useMemo, useState } from 'react'
import { getPeriodoMesAtual } from '../../../../services/util/date.service'
import MultiDeliveryCycleHttp from '../../../../services/api/https/deliveries/multi-delivery-cycle.http'
import { errorHandler } from '../../../../services/util/error.service'
import { getCentraisOperacoes } from '../../../../services/localstorage/localstorage.service'

const { dataInicial, dataFinal } = getPeriodoMesAtual()
const centraisStorage = getCentraisOperacoes()

const INITIAL_STATE = {
  loadingMessage: null,
  errorMessage: null,
  multiplosCiclos: [],
  showDialog: false,
  selectedCentral: centraisStorage && centraisStorage.length === 1 ? centraisStorage[0].id : '',
  selectedMultiCiclo: null,
  pInicial: dataInicial,
  pFinal: dataFinal,
  navigateToImportacao: false,
}

export function useMultiploCicloEntregaHook() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      // -------------------
      // Public Methods
      // -------------------

      async fetchMutiploCiclos(centralId, pInicial, pFinal) {
        try {
          if (centralId === '') {
            setState(prev => ({
              ...prev,
              errorMessage: 'Selecione a Central de Operações',
              loadingMessage: null,
            }))
          } else {
            setState(prev => ({
              ...prev,
              loadingMessage: 'Carregando os Multiplos Ciclos cadastrados . . .',
            }))

            const mCiclos = await MultiDeliveryCycleHttp.getAll(centralId, pInicial, pFinal)

            setState(prev => ({
              ...prev,
              loadingMessage: null,
              errorMessage: null,
              selectedCentral: centralId,
              multiplosCiclos: mCiclos,
            }))
          }
        } catch (e) {
          setState(prev => ({ ...prev, errorMessage: errorHandler(e), loadingMessage: null }))
        }
      },

      openDialog(showDialog, mCiclo = null) {
        setState(prev => {
          if (prev.selectedCentral === '') {
            prev.errorMessage = 'Selecione a Central de Operações'
          } else {
            prev.showDialog = showDialog
            prev.selectedMultiCiclo = mCiclo
          }
          return { ...prev }
        })
      },

      setMultiplosCiclos(mCiclos) {
        setState(prev => {
          prev.multiplosCiclos = mCiclos
          prev.loadingMessage = null
          return { ...prev }
        })
      },

      resetState() {
        setState(prev => {
          prev.errorMessage = null
          prev.loadingMessage = null
          prev.navigateToImportacao = false
          return { ...prev }
        })
      },

      // -------------------
      // Events
      // -------------------

      onMenuItemClicked(item, mCiclo) {
        switch (item) {
          case 'Editar':
            setState(prev => {
              prev.showDialog = true
              prev.selectedMultiCiclo = mCiclo
              return { ...prev }
            })
            break
          case 'Apagar':
            setState(prev => ({ ...prev, loadingMessage: 'Apagando os Ciclos . . .' }))

            MultiDeliveryCycleHttp.apagar(mCiclo.id)
              .then(() => {
                setState(prev => {
                  const mCiclos = prev.multiplosCiclos.filter(c => c.id !== mCiclo.id)
                  return { ...prev, multiplosCiclos: mCiclos, loadingMessage: null }
                })
              })
              .catch(e => {
                setState(prev => {
                  prev.errorMessage = errorHandler(e)
                  prev.loadingMessage = null
                  return { ...prev }
                })
              })
            break
          case 'Importação':
            setState(prev => {
              prev.navigateToImportacao = true
              prev.selectedMultiCiclo = mCiclo
              return { ...prev }
            })
            break
          default:
            break
        }
      },

      onModalResponse(action, payload) {
        switch (action) {
          case 'close':
            setState(prev => {
              prev.showDialog = false
              return { ...prev }
            })
            break
          case 'success':
            setState(prev => {
              const index = prev.multiplosCiclos.findIndex(m => m.id === payload.id)
              if (index !== -1) {
                prev.multiplosCiclos[index] = payload
              } else {
                prev.multiplosCiclos.unshift(payload)
              }
              prev.showDialog = false
              return { ...prev }
            })
            break
          case 'error':
            setState(prev => {
              prev.errorMessage = payload
              return { ...prev }
            })
            break
          default:
            break
        }
      },
    }
  }, [])

  return { state, localDispatch }
}
